import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DataService } from 'src/app/_helpers/dataservice.service';
import { AuthService } from 'src/app/_services';
import { icons } from '../constans/icons.constans';
import { MenuItemRender } from 'src/app/_models';

@Component({
  selector: 'app-new-header',
  templateUrl: './new-header.component.html',
  styleUrls: ['./new-header.component.css', '../../../assets/css/new-component-view.css', '../../../assets/css/new-buttons-theme.css']
})
export class NewHeaderComponent implements OnInit, OnDestroy {

  collapsed: boolean = false;
  private destroy$ = new Subject<void>();
  profilePicture: string;
  menuItems: MenuItemRender[];
  showMenuItem: boolean = false;
  icons: Record<string, Record<string, string>>;
  settingsPath: string = ''

  constructor(
    private dataService: DataService,
    private authService: AuthService
  ) { 
    this.icons = icons;
    this.settingsPath = '/new_configuration_layout';
    this.collapsed = JSON.parse(localStorage.getItem("statusMenu"));
    this.menuItems = JSON.parse(localStorage.getItem("accessmenu"));
  }

  ngOnInit() {
    this.getProfileData();
  }

  toggleDateRangePicker() {
    this.showMenuItem = !this.showMenuItem;
  }
  
  getProfileData() {
    if (this.authService.isAuthenticated()) {
      this.profilePicture = localStorage.getItem('userPhoto');
    }
  }

  toggleCollapsed() {
    this.collapsed = JSON.parse(localStorage.getItem("statusMenu"));
    this.collapsed = !this.collapsed;
    this.dataService.menuStatus(this.collapsed);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
